import { render, staticRenderFns } from "./editable_balance.vue?vue&type=template&id=22cc9e57&lang=pug&"
import script from "./editable_balance.vue?vue&type=script&lang=coffee&"
export * from "./editable_balance.vue?vue&type=script&lang=coffee&"
import style0 from "./editable_balance.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./editable_balance.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports